














































































































































































































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'

settings =
  name: "FormOnSiteSpace"
  vue:
    props: ['descriptor', 'wizard']

    computed:
      activation: -> @descriptor.activation_snapshot
      sellingItems: -> 
        { food, drink, merchandise } = @activation.selling
        food or drink or merchandise

      providingFood: -> !!@activation.distributing.food
      providingDrink: -> !!@activation.distributing.drink
      providingPromo: -> !!@activation.distributing.promo
      providingFoodOrDrink: -> @providingFood or @providingDrink

      consumable: ->
        c = 'food' if @providingFood
        c = 'drink' if @providingDrink
        c = 'food / drink' if @providingFood and @providingDrink
        c

      partnerBuyConfig: -> @wizard.partnerBuy?.config || {}

      sizingOptions: ->
        options = [
          { label: '10x10', value: 'booth_10x10', disabled: false }
          { label: '10x20', value: 'booth_10x20', disabled: false }
          { label: '20x40', value: 'booth_20x40', disabled: false }
          { label: '40x60', value: 'booth_40x60', disabled: false }
        ]
        spaceTypes = @partnerBuyConfig.spaces?.types
        return options unless spaceTypes?.length
        options.map((option) ->
          option.disabled = true unless option.value in spaceTypes
          option
        )
        options


    methods:
      updateDescriptorType: (descriptor_type) -> @descriptor.type = descriptor_type

      labelForSize: (size) ->
        return size.label unless size.disabled
        "#{size.label} (unavailable)"

export default VueOptions.vue settings
